<template>
  <v-dialog
    v-model="dialog"
    max-width="1700px"
    max-height="800px"
    width="90%"
    scrollable
    persistent
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
        color="primary"
        dark
      >
        <v-toolbar-title
          v-if="loading"
        >
          {{ 'Atendimento' }}
        </v-toolbar-title>
        <v-toolbar-title
          v-else
        >
          {{ id ? 'Editando Atendimento' : 'Cadastrando Atendimento' }}
        </v-toolbar-title>
        <v-spacer />

        <v-btn
          icon
          dark
          @click="cancel"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <base-loading v-if="loading" />
        <div v-else>
          <v-form
            ref="form"
            dense
            lazy-validation
          >
            <v-card
              elevation="0"
            >
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    v-model="atendimento_id"
                    dense
                    label="Atendimento Nº"
                    class="text-direita"
                    readonly
                    outlined
                    rounded
                    hide-details
                    style="font-weight: bold;"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <data-field
                    v-model="data_atendimento"
                    style-text-field
                    label="Data Atendimento *"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    :value="currencyFormatter(valor_total ?? 0)"
                    dense
                    label="Valor total"
                    class="text-direita"
                    prefix="R$"
                    readonly
                    hide-details
                    outlined
                    rounded
                    style="font-weight: bold;"
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="produtor_id"
                    :items="produtores"
                    :rules="[rules.required]"
                    autocomplete="off"
                    item-text="nome_razao_social"
                    item-value="id"
                    label="Produtor *"
                    dense
                    hide-details
                    validate-on-blur
                    outlined
                    rounded
                    @change="selectProdutor"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="fazenda_id"
                    dense
                    autocomplete="off"
                    :items="fazendasProdutor"
                    item-text="nome"
                    item-value="fazenda_id"
                    :rules="[rules.required]"
                    label="Fazenda *"
                    validate-on-blur
                    hide-details
                    outlined
                    rounded
                    :readonly="!produtor_id || fazendasProdutor.length === 0"
                    :loading="fazendasProdutor.length === 0 || !produtor_id"
                    @change="selectFazenda"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="tecnico_id"
                    :items="tecnicos"
                    :rules="[rules.required]"
                    :readonly="!fazenda_id"
                    autocomplete="off"
                    item-text="nome"
                    item-value="id"
                    label="Técnico *"
                    dense
                    hide-details
                    validate-on-blur
                    outlined
                    rounded
                    @change="selectTecnicoSetor"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                >
                  <v-autocomplete
                    v-model="tecnico_setor_id"
                    :items="setores_tecnico"
                    :rules="[rules.required]"
                    item-text="descricao"
                    item-value="id"
                    label="Setor *"
                    dense
                    outlined
                    rounded
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="3"
                >
                  <v-autocomplete
                    v-model="plano_pagamento_id"
                    :items="planos_pagamentos"
                    :rules="[rules.required]"
                    item-text="descricao"
                    item-value="id"
                    label="Plano de Pagamento *"
                    dense
                    outlined
                    rounded
                    @change="selectPlanoPagamento"
                  />
                </v-col>
              </v-row>
            </v-card>

            <v-tabs
              v-model="tabs"
              icons-and-text
            >
              <v-tabs-slider />
              <v-tab
                style="font-size: smaller;"
              >
                Serviços
                <v-icon>
                  mdi-package-variant-closed
                </v-icon>
              </v-tab>
              <v-tab
                style="font-size: smaller;"
              >
                Produtos
                <v-icon>
                  mdi-package-variant-closed
                </v-icon>
              </v-tab>
              <v-tab
                style="font-size: smaller;"
              >
                Observações
                <v-icon>
                  mdi-comment-text-outline
                </v-icon>
              </v-tab>
            </v-tabs>
            <v-tabs-items
              v-model="tabs"
              mandatory
            >
              <v-tab-item>
                <v-container
                  fluid
                  class="pt-1 pl-1 pr-1 pb-1"
                >
                  <v-container fluid>
                    <v-row>
                      <v-col>
                        <atendimento-servico-dialog
                          :key="unidade_negocio_id"
                          :cotacao-id="unidade_negocio_id"
                          :itens-selected="itens_servicos"
                          :tabela="tabela_plano_pagamento"
                          :disabled="!unidade_negocio_id"
                          @submit="addAtendimentoiItemServico"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <crud-list
                        v-model="itens_servicos"
                        :headers="headersService"
                        :actions="actionsServico"
                        :slots="[
                          'item.quantidade',
                          'item.valor_custo',
                          'item.valor_unitario',
                          'item.valor_subtotal',
                          'item.valor_desconto',
                          'item.valor_total',
                          'item.nome_servico',
                          'item.observacao',
                        ]"
                        :show-search="false"
                        :item-height="$vuetify.breakpoint.xl ? '202' : '200'"
                      >
                        <template v-slot:[`item.nome_servico`]="{ item }">
                          <span>{{ item.codProduto + ' - ' + item.nome_servico }}</span>
                        </template>
                        <template v-slot:[`item.valor_subtotal`]="{ item }">
                          <span>{{ currencyFormatter(item.valor_subtotal) }}</span>
                        </template>
                        <template v-slot:[`item.valor_desconto`]="{ item }">
                          <v-edit-dialog
                            :return-value.sync="item.valor_desconto"
                            large
                            :save-text="'Salvar'"
                            :cancel-text="'Cancelar'"
                            @save="save({
                              item,
                              field: 'quantidade',
                              value: item.icms,
                            })"
                          >
                            <span>{{ currencyFormatter(item.valor_desconto || 0) }}</span>
                            <v-icon
                              left
                              small
                              class="pl-2"
                              color="info darken-3"
                            >
                              mdi-pencil
                            </v-icon>
                            <template v-slot:input>
                              <base-vuetify-money
                                v-model="item.valor_desconto"
                                :options="money"
                                maxlength="10"
                                label="Valor de custo (R$)"
                              />
                            </template>
                          </v-edit-dialog>
                        </template>
                        <template v-slot:[`item.observacao`]="{ item }">
                          <v-edit-dialog
                            :return-value.sync="item.observacao"
                            large
                            :save-text="'Salvar'"
                            :cancel-text="'Cancelar'"
                          >
                            <span>{{ item.observacao }}</span>
                            <v-icon
                              left
                              small
                              class="pl-2"
                              color="info darken-3"
                            >
                              mdi-pencil
                            </v-icon>
                            <template v-slot:input>
                              <v-text-field
                                v-model="item.observacao"
                                :options="money"
                                maxlength="30"
                                label="Observação"
                              />
                            </template>
                          </v-edit-dialog>
                        </template>
                        <template v-slot:[`item.valor_unitario`]="{ item }">
                          <v-edit-dialog
                            :return-value.sync="item.valor_unitario"
                            large
                            :save-text="'Salvar'"
                            :cancel-text="'Cancelar'"
                            @save="save({
                              item,
                              field: 'quantidade',
                              value: item.icms,
                            })"
                          >
                            <span>{{ currencyFormatter(item.valor_unitario || 0) }}</span>
                            <v-icon
                              left
                              small
                              class="pl-2"
                              color="info darken-3"
                            >
                              mdi-pencil
                            </v-icon>
                            <template v-slot:input>
                              <base-vuetify-money
                                v-model="item.valor_unitario"
                                :options="money"
                                maxlength="10"
                                label="Valor unitario (R$)"
                              />
                            </template>
                          </v-edit-dialog>
                        </template>
                        <template v-slot:[`item.valor_total`]="{ item }">
                          <span>{{ currencyFormatter(item.valor_total) }}</span>
                        </template>
                        <template v-slot:[`item.quantidade`]="{ item }">
                          <v-edit-dialog
                            :return-value.sync="item.quantidade"
                            large
                            :save-text="'Salvar'"
                            :cancel-text="'Cancelar'"
                            @save="save({
                              item,
                              field: 'quantidade',
                              value: item.quantidade,
                            })"
                          >
                            <span>{{ formatQuantidade(item.quantidade) }}</span>
                            <v-icon
                              left
                              small
                              class="pl-2"
                              color="info darken-3"
                            >
                              mdi-pencil
                            </v-icon>
                            <template v-slot:input>
                              <v-text-field
                                v-model.number="item.quantidade"
                                type="number"
                                label="Quantidade"
                                min="0"
                                step="1"
                                autofocus
                                outlined
                                dense
                                rounded
                                class="mt-5"
                              />
                            </template>
                          </v-edit-dialog>
                        </template>
                      </crud-list>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container
                  fluid
                  class="pt-1 pl-1 pr-1 pb-1"
                >
                  <v-container fluid>
                    <v-row>
                      <v-col>
                        <atendimento-item-dialog
                          :key="unidade_negocio_id"
                          :cotacao-id="unidade_negocio_id"
                          :itens-selected="itens"
                          :tabela="tabela_plano_pagamento"
                          :disabled="!unidade_negocio_id"
                          @submit="addAtendimentoItem"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <crud-list
                        v-model="itens"
                        :headers="headers"
                        :actions="actions"
                        :slots="[
                          'item.quantidade',
                          'item.valor_custo',
                          'item.valor_unitario',
                          'item.valor_subtotal',
                          'item.valor_desconto',
                          'item.valor_total',
                          'item.nome_produto',
                          'item.observacao'
                        ]"
                        :show-search="false"
                        :item-height="$vuetify.breakpoint.xl ? '202' : '200'"
                      >
                        <template v-slot:[`item.nome_produto`]="{ item }">
                          <span>{{ item.codProduto + ' - ' + item.nome_produto }}</span>
                        </template>
                        <template v-slot:[`item.valor_subtotal`]="{ item }">
                          <span>{{ currencyFormatter(item.valor_subtotal) }}</span>
                        </template>
                        <template v-slot:[`item.observacao`]="{ item }">
                          <v-edit-dialog
                            :return-value.sync="item.observacao"
                            large
                            :save-text="'Salvar'"
                            :cancel-text="'Cancelar'"
                          >
                            <span>{{ item.observacao }}</span>
                            <v-icon
                              left
                              small
                              class="pl-2"
                              color="info darken-3"
                            >
                              mdi-pencil
                            </v-icon>
                            <template v-slot:input>
                              <v-text-field
                                v-model="item.observacao"
                                :options="money"
                                maxlength="30"
                                label="Observação"
                              />
                            </template>
                          </v-edit-dialog>
                        </template>
                        <template v-slot:[`item.valor_desconto`]="{ item }">
                          <v-edit-dialog
                            :return-value.sync="item.valor_desconto"
                            large
                            :save-text="'Salvar'"
                            :cancel-text="'Cancelar'"
                            @save="save({
                              item,
                              field: 'quantidade',
                              value: item.icms,
                            })"
                          >
                            <span>{{ currencyFormatter(item.valor_desconto || 0) }}</span>
                            <v-icon
                              left
                              small
                              class="pl-2"
                              color="info darken-3"
                            >
                              mdi-pencil
                            </v-icon>
                            <template v-slot:input>
                              <base-vuetify-money
                                v-model="item.valor_desconto"
                                :options="money"
                                maxlength="10"
                                label="Valor do desconto (R$)"
                              />
                            </template>
                          </v-edit-dialog>
                        </template>
                        <template v-slot:[`item.valor_unitario`]="{ item }">
                          <v-edit-dialog
                            :return-value.sync="item.valor_unitario"
                            large
                            :save-text="'Salvar'"
                            :cancel-text="'Cancelar'"
                            @save="save({
                              item,
                              field: 'quantidade',
                              value: item.icms,
                            })"
                          >
                            <span>{{ currencyFormatter(item.valor_unitario || 0) }}</span>
                            <v-icon
                              left
                              small
                              class="pl-2"
                              color="info darken-3"
                            >
                              mdi-pencil
                            </v-icon>
                            <template v-slot:input>
                              <base-vuetify-money
                                v-model="item.valor_unitario"
                                :options="money"
                                maxlength="10"
                                label="Valor unitario (R$)"
                              />
                            </template>
                          </v-edit-dialog>
                        </template>
                        <template v-slot:[`item.valor_total`]="{ item }">
                          <span>{{ currencyFormatter(item.valor_total) }}</span>
                        </template>
                        <template v-slot:[`item.quantidade`]="{ item }">
                          <v-edit-dialog
                            :return-value.sync="item.quantidade"
                            large
                            :save-text="'Salvar'"
                            :cancel-text="'Cancelar'"
                            @save="save({
                              item,
                              field: 'quantidade',
                              value: item.quantidade,
                            })"
                          >
                            <span>{{ item.quantidade }}</span>
                            <v-icon
                              left
                              small
                              class="pl-2"
                              color="info darken-3"
                            >
                              mdi-pencil
                            </v-icon>
                            <template v-slot:input>
                              <v-text-field
                                v-model.number="item.quantidade"
                                type="number"
                                label="Quantidade"
                              />
                            </template>
                          </v-edit-dialog>
                        </template>
                      </crud-list>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container
                  fluid
                  :style="{ minHeight: '240px' }"
                >
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-textarea
                        v-model="observacao"
                        maxlength="255"
                        height="65"
                        label="Observação"
                        dense
                        no-resize
                        validate-on-blur
                        outlined
                        hide-details
                        rounded
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-form>
        </div>
      </v-card-text>
      <v-card-actions
        class="justify-end"
      >
        <v-btn
          class="text-none text-white"
          color="error"
          rounded
          @click="cancel"
        >
          <v-icon
            dark
            left
          >
            mdi-minus-circle
          </v-icon>
          Cancelar
        </v-btn>
        <v-btn
          class="text-none text-white"
          color="success"
          depressed
          rounded
          :loading="loading"
          :disabled="loading || desabilitarBotao"
          @click="submit"
        >
          <v-icon
            dark
            left
          >
            mdi-checkbox-marked-circle
          </v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import {
    CLOSE,
    SET_STATE,
    SUBMIT,
    PUSH_ITEM,
    DELETE_ITEM,
    DELETE_SUBMIT,
    CREATE_ATENDIMENTO,
    DELETE_ITEM_SERVICO,
    PUSH_ITEM_SERVICO,
    LOAD_SERVICOS_UNIDADES,
    LOAD_PRODUTOS_UNIDADES,
    SET_TABELA_PLANO_PAGAMENTO,
    LOAD_SETOR_TECNICO,
  } from '../../store/modules/forms/atendimento'
  import { LOAD_BATCH_PRODUTORES_FAZENDA } from '../../store/modules/produtores'
  import { LOAD_FAZENDAS_BY_PRODUTOR } from '../../store/modules/fazendas'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import { mapFields, mapMultiRowFields } from 'vuex-map-fields'
  import { currencyFormatter, dateFormatter } from '../../utils/formatter'
  import { sortCurrency } from '../../utils/sorts'
  import AtendimentoItemDialog from './AtendimentoItemDialog.vue'
  import AtendimentoServicoDialog from './AtendimentoServicoDialog.vue'
  import axios from '../../api/axios'

  export default {
    name: 'AtendimentoDialog',
    components: {
      AtendimentoItemDialog,
      AtendimentoServicoDialog,
    },

    props: {
      bootstrap: {
        type: Function,
        required: true,
      },

    },

    data () {
      return {
        tabs: null,
        currencyFormatter,
        sortCurrency,
        radioGroup: null,
        money: {
          locale: 'pt-BR',
          precision: 2,
          prefix: 'R$ ',
        },
        porecent: {
          locale: 'pt-BR',
          precision: 2,
          suffix: '%',
        },
        actions: [
          {
            icon: 'mdi-delete',
            title: 'Excluir',
            click: item => {
              this.deleteItem(item)
            },
            color: '#D50000',
          },
        ],
        actionsServico: [
          {
            icon: 'mdi-delete',
            title: 'Excluir',
            click: item => {
              this.deleteItemServico(item)
            },
            color: '#D50000',
          },
        ],

        headers: [
          { align: 'center', sortable: false, text: 'Ações', value: 'actions', width: 'auto' },
          { align: 'left', sortable: true, text: 'Produto', value: 'nome_produto', width: 'auto' },
          { align: 'center', sortable: true, text: 'UN', value: 'unidade_medida', width: 'auto' },
          { align: 'center', sortable: true, text: 'Volume', value: 'volume', width: 'auto' },
          { align: 'right', sortable: true, text: 'Quantidade', value: 'quantidade', width: 'auto' },
          { align: 'end', sortable: true, text: 'Valor unitario (R$)', value: 'valor_unitario', width: 'auto', sort: sortCurrency },
          { align: 'end', sortable: true, text: 'Valor bruto (R$)', value: 'valor_subtotal', width: 'auto', sort: sortCurrency },
          { align: 'end', sortable: true, text: 'Valor descontos (R$)', value: 'valor_desconto', width: 'auto', sort: sortCurrency },
          { align: 'end', sortable: true, text: 'Valor Liquido (R$)', value: 'valor_total', width: 'auto', sort: sortCurrency },
          { align: 'left', sortable: true, text: 'Categoria', value: 'nome_categoria', width: 'auto' },
          { align: 'left', sortable: true, text: 'Observação', value: 'observacao', width: 'auto' },
        ],
        headersService: [
          { align: 'center', sortable: false, text: 'Ações', value: 'actions', width: 'auto' },
          { align: 'left', sortable: true, text: 'Produto', value: 'nome_servico', width: 'auto' },
          { align: 'center', sortable: true, text: 'UN', value: 'unidade_medida', width: 'auto' },
          { align: 'end', sortable: true, text: 'Quantidade', value: 'quantidade', width: 'auto' },
          { align: 'end', sortable: true, text: 'Valor unitario (R$)', value: 'valor_unitario', width: 'auto', sort: sortCurrency },
          { align: 'end', sortable: true, text: 'Valor bruto (R$)', value: 'valor_subtotal', width: 'auto', sort: sortCurrency },
          { align: 'end', sortable: true, text: 'Valor descontos (R$)', value: 'valor_desconto', width: 'auto', sort: sortCurrency },
          { align: 'end', sortable: true, text: 'Valor Liquido (R$)', value: 'valor_total', width: 'auto', sort: sortCurrency },
          { align: 'left', sortable: true, text: 'Categoria', value: 'nome_categoria', width: 'auto' },
          { align: 'left', sortable: true, text: 'Observação', value: 'observacao', width: 'auto' },
        ],
      }
    },

    computed: {
      ...mapState('form/atendimento', [
        'loading',
        'rules',
        'dialog',
        'produtos',
        'tecnicos',
        'planos_pagamentos',
        'tabela_plano_pagamento',
        'setores_tecnico',
        'desabilitarBotao',
      ]),
      ...mapFields('form', [
        'data.id',
        'data.user_id',
        'data.atendimento_id',
        'data.unidade_negocio_id',
        'data.nome_produtor',
        'data.nome_fazenda',
        'data.data_atendimento',
        'data.observacao',
        'data.valor_total',
        'data.produtor_id',
        'data.fazenda_id',
        'data.tipo_atendimento',
        'data.observacao_atendimento',
        'data.tecnico_id',
        'data.plano_pagamento_id',
        'data.tecnico_setor_id',
      ]),
      ...mapMultiRowFields('form', [
        'data.itens',
        'data.itens_servicos',
      ]),
      ...mapState('produtores', ['produtores']),
      ...mapState('fazendas', ['fazendas', 'fazendasProdutor']),
      produtosCotacao () {
        return this.itens ? this.itens : []
      },
      // listFazendas () {
      //   if (!this.produtor_id) return []
      //   console.log(this.produtores, this.fazendas, this.produtor_id)
      //   const produtor = this.produtores.find(produtor => produtor.id === this.produtor_id).fazendas.map(fazenda => fazenda.id)

      //   if (!produtor) return []
      //   console.log(produtor)

      //   return this.fazendas.filter((fazenda) => produtor.includes(fazenda.id))
      // },
    },
    watch: {
      async loading (val) {
        if (!val) {
          this.$nextTick(async () => {
            if (this.id) await this.LOAD_FAZENDAS_BY_PRODUTOR(this.produtor_id)
            if (this.id) await this.LOAD_SETOR_TECNICO(this.tecnico_id)
          })
        }
      },
    },
    async created () {
      await this.LOAD_BATCH_PRODUTORES_FAZENDA()
    },
    methods: {
      ...mapMutations('form/atendimento', [CLOSE, SET_STATE]),
      ...mapActions('form/atendimento', [
        SUBMIT,
        PUSH_ITEM,
        PUSH_ITEM_SERVICO,
        DELETE_ITEM_SERVICO,
        DELETE_ITEM,
        DELETE_SUBMIT,
        CREATE_ATENDIMENTO,
        LOAD_SERVICOS_UNIDADES,
        LOAD_PRODUTOS_UNIDADES,
        SET_TABELA_PLANO_PAGAMENTO,
        LOAD_SETOR_TECNICO,
      ]),
      ...mapActions('produtores', [LOAD_BATCH_PRODUTORES_FAZENDA]),
      ...mapActions('fazendas', [LOAD_FAZENDAS_BY_PRODUTOR]),
      async deleteItem (item) {
        await this.DELETE_ITEM(item)
        await this.recalculoPrecoVenda()
      },
      async deleteItemServico (item) {
        await this.DELETE_ITEM_SERVICO(item)
        await this.recalculoPrecoVenda()
      },
      submit () {
        if (!this.itens.length && !this.itens_servicos.length) return window.Toast.fire('Atenção', 'Adicione pelo menos um produto ou serviço ao atendimento', 'warning')

        if (!this.$refs.form.validate()) {
          return window.Toast.fire('Atenção', 'Preencha todos os campos obrigatórios', 'warning')
        }
        let validate = true

        for (let i = 0; i < this.itens.length; i++) {
          if (!this.itens[i].quantidade) {
            this.tabs = 1
            window.Toast.fire('Atenção', 'Preencha a quantidade de todos os produtos', 'warning')
            validate = false
            break
          }
        }
        for (let i = 0; i < this.itens_servicos.length; i++) {
          if (!this.itens_servicos[i].quantidade) {
            this.tabs = 0
            window.Toast.fire('Atenção', 'Preencha a quantidade de todos os serviços', 'warning')
            validate = false
            break
          }
        }

        if (!validate) {
          return this.$refs.form.validate()
        }

        this.tabs = 0
        if (!this.id) {
          this.CREATE_ATENDIMENTO()
          return
        }
        this.SUBMIT()
      },
      cancel () {
        this.tabs = 0
        this.signature = ''
        this.CLOSE()
      },
      formataData (date) {
        return dateFormatter(date)
      },
      save (event) {
        this.recalculoPrecoVenda()
      },
      addAtendimentoItem (item) {
        this.PUSH_ITEM(item)
        this.recalculoPrecoVenda()
        // this.valor_total += this.produtosCotacao.reduce((acc, item) => acc + Number(item.valor_total), 0)
      },
      addAtendimentoiItemServico (item) {
        this.PUSH_ITEM_SERVICO(item)
        this.recalculoPrecoVenda()
        // this.valor_total += this.itens_servicos.reduce((acc, item) => acc + Number(item.valor_total), 0)
      },

      selectFazenda (fazendaId) {
        const fazenda = this.fazendasProdutor.find(fazenda => fazenda.fazenda_id === fazendaId)

        fazenda.tecnico_id ? this.tecnico_id = fazenda.tecnico_id : this.tecnico_id = null
        fazenda.plano_pagamento_id ? this.plano_pagamento_id = fazenda.plano_pagamento_id : this.plano_pagamento_id = null

        if (!fazenda) {
          this.unidade_negocio_id = null
          return
        }
        this.unidade_negocio_id = fazenda.unidade_negocio_id
        this.LOAD_PRODUTOS_UNIDADES(this.unidade_negocio_id)
        this.LOAD_SERVICOS_UNIDADES(this.unidade_negocio_id)
        this.selectTecnicoSetor(this.tecnico_id)
        this.selectPlanoPagamento(this.plano_pagamento_id)
      },
      async selectProdutor (value) {
        this.$nextTick(() => {
          this.fazenda_id = null
          this.plano_pagamento_id = null
          this.tecnico_id = null
          this.tecnico_setor_id = null

          this.$refs.form.resetValidation()
        })

        const produtor = this.produtores.find(produtor => produtor.id === value)
        if (!produtor) {
          this.selectFazenda(null)
          return
        }
        await this.LOAD_FAZENDAS_BY_PRODUTOR(value)

        if (produtor.fazendas && produtor.fazendas.length === 1) {
          this.fazenda_id = produtor.fazendas[0].id
          this.selectFazenda(this.fazenda_id)
        }

        // const produtorId = value
        // const fazenda = this.fazendas.find(fazenda => fazenda.id === this.fazenda_id)
        // let produtor = null
        // if (fazenda && fazenda.produtores) {
        //   produtor = fazenda.produtores.find(produtor => produtor.id === produtorId)
        // }
        // if (produtor && produtor.cadastro && produtor.cadastro.plano_pagamento_id) {
        //   this.plano_pagamento_id = produtor.cadastro.plano_pagamento_id
        //   this.selectPlanoPagamento(this.plano_pagamento_id)
        // }
      },
      async selectTecnicoSetor (value) {
        await this.LOAD_SETOR_TECNICO(value)
        this.$nextTick(async () => {
          this.tecnico_setor_id = null
          if (this.setores_tecnico.length === 1) {
            this.tecnico_setor_id = this.setores_tecnico[0].id
          }
        })
      },
      async downloadImage (signature_id) {
        if (!signature_id) return

        try {
          const url = `${axios.defaults.baseURL}/public/image/cotacao/signatures/${this.signature_id}`

          const response = await axios.get(url, { responseType: 'blob' })
          const reader = new FileReader()
          reader.readAsDataURL(response.data)
          reader.onload = () => {
            const img = new Image()
            img.src = reader.result
            img.onload = () => {
              const canvas = document.createElement('canvas')
              const ctx = canvas.getContext('2d')
              canvas.width = img.height
              canvas.height = img.width
              ctx.translate(canvas.width / 2, canvas.height / 2)
              ctx.rotate(90 * Math.PI / 180)
              ctx.drawImage(img, -img.width / 2, -img.height / 2)

              this.signature = canvas.toDataURL('image/png')
            }
          }
        } catch (e) {
          const response = await fetch(window.location.origin + '/img/errorAssinatura.png')
          const blob = await response.blob()

          this.signature = new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(blob)
            reader.onload = () => {
              const img = new Image()
              img.src = reader.result
              img.onload = () => {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                canvas.width = img.height
                canvas.height = img.width
                ctx.translate(canvas.width / 2, canvas.height / 2)
                ctx.rotate(90 * Math.PI / 180)
                ctx.drawImage(img, -img.width / 2, -img.height / 2)

                this.signature = canvas.toDataURL('image/png')
                resolve()
              }
            }
          })
        }
      },

      filterItem (item, consulta, nome) {
        if (nome.toLowerCase().includes(consulta.toLowerCase())) return true
        if (item.identificador.includes(consulta)) return true
        if (item.complemento && item.complemento.toLowerCase().includes(consulta.toLowerCase())) return true
        return false
      },

      recalculoPrecoVenda () {
        let totalCotacao = 0
        this.produtosCotacao.forEach(item => {
          item.valor_total = item.valor_unitario * item.quantidade - item.valor_desconto
          item.valor_subtotal = item.valor_unitario * item.quantidade
          totalCotacao += item.valor_total
          const produtoEncontrado = this.produtos.find(produto => produto.codigo === item.codProduto)
          if (produtoEncontrado && produtoEncontrado.volume) {
            item.volume = Number(produtoEncontrado.volume) * item.quantidade
          }
          if (item.valor_desconto > item.valor_subtotal) {
            item.valor_desconto = 0
            this.timerUpdateDescontos()
          }
        })
        this.itens_servicos.forEach(item => {
          item.valor_total = item.valor_unitario * item.quantidade - item.valor_desconto
          item.valor_subtotal = item.valor_unitario * item.quantidade
          totalCotacao += item.valor_total
          if (item.valor_desconto > item.valor_subtotal) {
            item.valor_desconto = 0
            this.timerUpdateDescontos()
          }
        })
        this.valor_total = totalCotacao
      },

      timerUpdateDescontos () {
        const tempo = 100 // 1 segundo
        window.Toast.fire('Atenção', 'O valor de descontos não pode ser maior que o valor bruto', 'warning')
        setTimeout(() => {
          this.recalculoPrecoVenda()
        }, tempo)
      },

      selectPlanoPagamento (planoPagamentoId) {
        const plano = this.planos_pagamentos.find(plano => plano.id === planoPagamentoId)
        if (plano) {
          this.SET_TABELA_PLANO_PAGAMENTO(plano.tabela)
        } else {
          this.SET_TABELA_PLANO_PAGAMENTO(null)
        }
      },
      formatQuantidade (value) {
        const num = Number(value)
        return isNaN(num) ? '0' : Math.round(num).toString()
      },
    },
  }
</script>

<style scoped>
  .v-tabs .v-tabs-bar {
    height: 50px;
  }
</style>
